import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Switch,
  Modal,
  Space,
  Checkbox,
} from "antd";
import signinLogo from "../../assets/images/logo.svg";
import signinbg from "../../assets/images/sign-in-bg.svg";
import MailIcon from "../../assets/images/input-icons/mail-icon.svg";
import UserIcon from "../../assets/images/input-icons/user-icon.svg";
import PasswordIcon from "../../assets/images/input-icons/lock-icon.svg";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import apiPath from "../../constants/apiPath";
import encryptDecrypt from "../../helper/encryptDecrypt";

import Footer from "../../components/layout/Footer";
import Container from "react-bootstrap/Container";
const { Title } = Typography;
const { Content } = Layout;

const OtpIndex = () => {
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const { request } = useRequest();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [form] = Form.useForm();
  const [rememberMe, setRememberMe] = useState(false);
  const location = useLocation();
  const email = location.state?.email;
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        // If current has value, just clear it
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // If current is empty, move to previous
        const newOtp = [...otp];
        newOtp[index - 1] = "";
        setOtp(newOtp);
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
    }
  };

  console.log(email, "email");
  const handleRememberMeChange = (e) => {
    console.log(e.target.checked);
    setRememberMe(e.target.checked);
  };

  const onFinish = (values) => {
    onSubmit(values);
  };


  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };


  const [otp, setOtp] = useState(["", "", "", ""]);

  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      // Auto-focus to next input
      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };


  const onSubmit = () => {


    // if (!email)
    //   return ShowToast("Please enter email to sign in", Severty.ERROR);

    const payload = {};
    // if (!email) return ShowToast("Please enter valid email ", Severty.ERROR);

    console.log(payload, "fkjdhkd");

    setLoading(true);
    payload.email = email;
    payload.otp = otp.join("");

    request({
      url: apiPath.verifyOTP,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "fghdjh data");
        if (data.status) {
          setIsLoggedIn(true);


          ShowToast(data.message, Severty.SUCCESS);


          setTimeout(() => navigate("/sign-in"), 200);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Container>
          <Content className="signin">
            <div className="signup-logo-header">
              <img src={signinLogo} alt="" />
            </div>
            <Row>
              <Col span={24} lg={12} className="contant-bg-sign">
                <div className="signin-box">
                  <Row justify="space-around">
                    <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                      <div className="signup-form">
                        <Title className="mb-15">OTP Verification</Title>
                        <h6 className="sub-headding-sign">
                          Enter the verification code we sent to your Email ID{" "}
                          <Link className="mail-daircket">
                            {" "}
                            {email}
                          </Link>
                        </h6>
                        <Form
                          form={form}
                          onFinish={onFinish}
                          onFinishFailed={onFinishFailed}
                          layout="vertical"
                          className="row-col"
                        >
                          <Form.Item
                            name="otp"
                            rules={[
                              {
                                required: true,
                                message: "Please enter the OTP",
                              },
                              {
                                validator: (_, value) => {
                                  return otp.join("").length === 4
                                    ? Promise.resolve()
                                    : Promise.reject(
                                      new Error("OTP must be 4 digits")
                                    );
                                },
                              },
                            ]}
                          >
                            <div className="otp-inputs-line">
                              {otp.map((digit, index) => (
                                <Input
                                  key={index}
                                  id={`otp-${index}`}
                                  maxLength={1}
                                  value={digit}
                                  onChange={(e) =>
                                    handleChange(e.target.value, index)
                                  }
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                  style={{ width: "3rem", textAlign: "center" }}
                                />
                              ))}
                            </div>
                          </Form.Item>
                          {/* <div className="forgot-pass">
                            <Form.Item
                              name="remember"
                              className="aligin-center"
                              valuePropName="checked"
                            >
                              <Checkbox
                                className="rem-check"
                                checked={rememberMe}
                                onChange={handleRememberMeChange}
                              >
                                Didn’t receive OTP?
                              </Checkbox>
                            </Form.Item>
                            <div className="resend-otp-main">
                              Resend OTP
                              <span> 50s</span>
                            </div>
                          </div> */}
                          <Form.Item className="sign-footer-button">
                            <Button
                              className="float-right"
                              type="primary"
                              htmlType="submit"
                            // onClick={() => navigate("/successfully-verified")}
                            >
                              Continue
                            </Button>
                          </Form.Item>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                <div className="signin_img">
                  <img src={signinbg} />
                </div>
              </Col>
            </Row>
          </Content>
        </Container>
        <Footer />
      </Layout>
    </>
  );
};

export default OtpIndex;
